import {createApi} from '@reduxjs/toolkit/dist/query/react';
import {axiosBaseQuery, REFETCH_POLICY} from 'src/axiosBaseQuery';
import {BusinessRegistrationRequest, CompleteRequest, DefaultAuthResponse, DefaultResponse,} from 'src/types';
import {CompanyRegistrationRequest, DriverRegistrationRequest} from 'src/types/registration';
import {ManualDriverRegistrationRequest} from 'src/types/users';
import {getBaseURL} from 'src/utils/helper';

export const registerApi = createApi({
    reducerPath: 'registerApi',
    ...REFETCH_POLICY,
    baseQuery: axiosBaseQuery({
        baseUrl: String(getBaseURL() + '/registration'),
    }),
    endpoints: (build) => {
        return {
            registerDrivers: build.mutation<DefaultResponse, DriverRegistrationRequest>({
                query: (data) => ({url: '/drivers', method: 'post', data}),
            }),
            registerCompanies: build.mutation<DefaultResponse, CompanyRegistrationRequest>({
                query: (data) => ({url: '/companies', method: 'post', data}),
            }),
            addNewUser: build.mutation<DefaultResponse, ManualDriverRegistrationRequest>({
                query: (data) => ({url: '/drivers/manual', method: 'post', data}),
            }),
            confirm: build.mutation<DefaultAuthResponse, string>({
                query: (hash) => ({url: '/confirm', method: 'post', params: {hash}}),
            }),
            confirmResend: build.mutation<DefaultAuthResponse, string>({
                query: (email) => ({url: '/confirm/resend', method: 'post', params: {email}}),
            }),
            addNewBusiness: build.mutation<DefaultResponse, BusinessRegistrationRequest>({
                query: (data) => ({url: '/business', method: 'post', data}),
            }),
            complete: build.mutation<DefaultAuthResponse, CompleteRequest>({
                query: ({data, params}) => ({url: '/complete', method: 'post', data, params}),
            }),
            completeResend: build.mutation<DefaultResponse, string>({
                query: (email) => ({url: '/complete/resend', method: 'post', params: {email}}),
            }),
            getRegistrationLink: build.query<DefaultResponse, { email: string; businessId: number }>({
                query: ({email, businessId}) => ({
                    url: '/link',
                    method: 'get',
                    params: {email, businessId}
                }),
            }),
        };
    },
});
